import React from "react"
import styled from "styled-components"
import { connect } from "react-redux"
import { Link } from "react-router-dom"
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome"
import { faThList, faSearch } from "@fortawesome/free-solid-svg-icons"
import { menuData } from "utils/data"

const Container = styled.div`
		width: 100%;
		height: 60px;
		background: rgba(0, 0, 0, 0.65);
		box-shadow: 0 3px 6px rgba(0, 0, 0, 0.5);
		position: absolute;
		top: 0;
		z-index: 66;
		@media (max-width: 767px) {
			height: 50px;
		}
	`,
	Nav = styled.div`
		height: 100%;
	`,
	Links = styled(Link)`
		height: 100%;
		padding: 0 20px;
		color: #ccc;
		text-decoration: none;
		float: left;
		display: flex;
		flex-direction: column;
		justify-content: center;
		align-items: center;
		transition: 0.3s;
		&:hover {
			color: #fff;
			text-shadow: 0 0 10px #69e0ff, 0 0 20px #69e0ff, 0 0 40px #69e0ff;
		}
	`,
	CTitle = styled.h3`
		font-size: 16px;
		font-weight: bold;
		line-height: 22px;
	`,
	ETitle = styled.p`
		font-size: 12px;
		opacity: 0.6;
	`,
	Btn = styled.button`
		width: 60px;
		height: 100%;
		padding: 0;
		background: transparent;
		outline: none;
		border: none;
		transition: 0.3s;
		position: absolute;
		${(props) => (props.meta === "show" ? { left: 0 } : "")};
		${(props) => (props.meta === "search" ? { right: 0 } : "")};
		&:hover,
		&:active {
			background: rgba(255, 255, 255, 0.2);
		}
		@media (max-width: 767px) {
			width: 50px;
		}
	`,
	BtnIcon = styled(FontAwesomeIcon)`
		color: #ccc;
		font-size: 18px;
	`

function Header(props) {
	return (
		<Container>
			<Btn className="d-md-none" meta="show" onClick={() => props.sidebarHandle()}>
				<BtnIcon icon={faThList} />
			</Btn>
			<Nav className="container d-none d-md-block">
				{menuData.map((item, index) => (
					<Links to={item.to} key={index}>
						<CTitle>{item.cTitle}</CTitle>
						<ETitle>{item.eTitle}</ETitle>
					</Links>
				))}
			</Nav>
			<Btn className="d-md-none" meta="search">
				<BtnIcon icon={faSearch} />
			</Btn>
		</Container>
	)
}

export default connect(
	(state) => ({ sideShow: state.control.sideShow }),
	(dispatch) => ({
		sidebarHandle: () => dispatch({ type: "SIDESHOW_HANDLE" }),
	})
)(Header)
